import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollDaysCalculationResponse  {
    _originalTypeClassName = "zERP.BO.PayrollDaysCalculationResponse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollDaysCalculationResponse.translate = translateService;
}
this.WorkingDays = 0;
this.InsuredDays = 0;
this.Hours = 0;
this.PayrollDaysCalculationResponseKey = null;
this._key = this.PayrollDaysCalculationResponseKey = 0; 
}

static translate: TranslateService;
_key: any;
WorkingDays:any;
InsuredDays:any;
Hours:any;
private _PayrollDaysCalculationResponseKey:any;
get PayrollDaysCalculationResponseKey(): any {
    return this._PayrollDaysCalculationResponseKey;
  }
set PayrollDaysCalculationResponseKey(value: any) {
    this._PayrollDaysCalculationResponseKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollDaysCalculationResponseKey == null || $this.PayrollDaysCalculationResponseKey == 0;
            }


}